import { styled } from "styled-components";
import { BiDotsHorizontalRounded } from "react-icons/bi";

export const PopupWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const DotsWrapper = styled.div`
  > svg {
    cursor: pointer;
    width: 1.5rem;
    height: 1.5rem;
    color: ${(props) => props.theme.colors.font.grey2};
    transition: color 0.2s;

    &:hover {
      color: ${(props) => props.theme.colors.font.primary};
    }
  }
`;

export const TablePopupWraper = styled.div<{ $top: number; $left: number }>`
  height: auto;
  width: 10rem;
  display: flex;
  flex-direction: column;
  position: fixed;
  top: ${(props) => props.$top}px;
  left: ${(props) => props.$left}px;
  background-color: #ffffff;
  border-radius: 0.5rem;
  border: 1px solid #E5E7EB;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  z-index: 9999;
`;

export const PopupItem = styled.div<{
  isDeleteField?: boolean;
  hasCustomColor?: boolean;
}>`
  height: auto;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5rem;
  padding: 0.625rem 0.75rem;
  cursor: pointer;
  user-select: none;
  transition: background-color 0.2s;
  font-size: 0.875rem;
  color: ${props => props.hasCustomColor ? 'inherit' : '#374151'};

  &:hover {
    background-color: #F9FAFB;
  }

  &:first-child {
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
  }

  &:last-child {
    border-bottom-left-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }
`;

export const IconWrapper = styled.div<{
  color?: string;
}>`
  align-items: center;
  justify-content: center;
  display: flex;
  flex-shrink: 0;
  color: ${(p) => p.color || "#6B7280"};

  > svg {
    height: 1rem;
    width: 1rem;
  }
`;

export const PopupText = styled.div<{
  color?: string;
}>`
  display: flex;
  justify-content: flex-start;
  flex: 1;
  font-weight: 500;
  color: ${(p) => p.color || "inherit"};
`;

export const DotsIcon = styled(BiDotsHorizontalRounded)``;
